import efs from './overview.json';
import widgets from './widgets';

export default [efs, ...widgets];
